import { EToasterStatus, showToast } from '../../../utils/showToast';

interface ApiError {
    response?: {
        data?: {
            message?: string;
        };
    };
}

const TOAST_MESSAGES = {
    UPLOAD_SUCCESS: 'Thumbnail uploaded successfully',
    UPLOAD_ERROR: 'Failed to update thumbnail',
    REMOVE_SUCCESS: 'Thumbnail removed successfully',
    REMOVE_ERROR: 'Failed to remove thumbnail',
    DEFAULT_ERROR: 'Please try again'
} as const;

export const useProjectToasts = () => {
    const showSuccessToast = (message: string) => {
        showToast({
            message,
            status: EToasterStatus.SUCCESS
        });
    };

    const showErrorToast = (message: string, error?: ApiError) => {
        showToast({
            message,
            status: EToasterStatus.ERROR,
            description: error?.response?.data?.message || TOAST_MESSAGES.DEFAULT_ERROR
        });
    };

    const showUploadSuccess = () => showSuccessToast(TOAST_MESSAGES.UPLOAD_SUCCESS);
    const showUploadError = (error?: ApiError) => showErrorToast(TOAST_MESSAGES.UPLOAD_ERROR, error);
    const showRemoveSuccess = () => showSuccessToast(TOAST_MESSAGES.REMOVE_SUCCESS);
    const showRemoveError = (error?: ApiError) => showErrorToast(TOAST_MESSAGES.REMOVE_ERROR, error);

    return {
        showUploadSuccess,
        showUploadError,
        showRemoveSuccess,
        showRemoveError
    };
};
